@media screen and (max-width: 1400px) {
  .ugc-review-images-wrap {
    .ugc-review-image {
      &:nth-of-type(n + 8) {
        display: none;
      }
    }
  }
}

@media screen and (max-width: 1300px) {
  .ugc-review-images-wrap {
    .ugc-review-image {
      &:nth-of-type(n + 6) {
        display: none;
      }
    }
  }
}

@media screen and (max-width: 1000px) {
  .ugc-review-images-wrap {
    .ugc-review-image {
      &:nth-of-type(n + 5) {
        display: none;
      }
    }
  }
}
